import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import PageHeader from '../components/PageHeader'
import BackHome from '../components/BackHome'
import { useFirebase } from "gatsby-plugin-firebase"

import pic08 from '../assets/images/inaki-del-olmo-NIJuEQw0RKg-unsplash.jpg'
import pic09 from '../assets/images/michael-longmire-3Mu0iQgLQto-unsplash.jpg'

const Oprojekcie = (props) => {

    useFirebase(firebase => {
        firebase
          .analytics()
          .logEvent("visited_o_projekcie")
      }, [])

    return <Layout>
        <Helmet>
            <title>O Projekcie - Uczelnie Szkołom – o finansach z NBP</title>
            <meta name="description" content="O Projekcie" />
        </Helmet>

        <PageHeader headerText="O Projekcie"/>

        <div id="main">
            <section id="one">
                <div className="inner">
                    <header className="major2">
                        <h2>Informacje</h2>
                    </header>
                    <p>Podhalańska Państwowa Uczelnia Zawodowa w Nowym Targu uzyskała grant Narodowego Banku Polskiego w konkursie "<strong>Uczelnie Szkołom – o finansach z NBP</strong>". Doświadczeni wykładowcy i praktycy Podhalańskiego Ośrodka Nauk Ekonomicznych – jednostki wspólnej PPUZ w Nowym Targu i UE w Krakowie – przeprowadzą zajęcia dotyczące ekonomii i bankowości <u>dla uczniów klas drugich i trzecich szkół średnich z terenu powiatów nowotarskiego, suskiego oraz tatrzańskiego</u>.
                    </p>
                    <p>Zapraszamy do wzięcia udziału w zajęciach!</p>
                    <ul className="actions">
                        <li><Link to="/rejestracja" className="button next">Rejestracja</Link></li>
                    </ul>
                </div>
            </section>
            <section id="two" className="spotlights">
                <section>
                    <img src={pic08} alt="" />
                    <div className="content">
                        <div className="inner">
                            <header className="major2">
                                <h3>Cel projektu</h3>
                            </header>
                            <p><strong>Głównym celem projektu</strong> jest poszerzenie wiedzy i umiejętności praktycznych uczniów klas II i III szkół średnich w zakresie rynków finansowych i zarządzania finansami osobistymi. Grupa docelowa to 350 osób uczniów szkół średnich.<br />
                            Cel ten będzie realizowany za pomocą innowacyjnych metod dydaktycznych łączących teorię z praktyką, wykorzystując przykładowo analizę case study, grywalizację czy narzędzia w postaci kalkulatorów finansowych zalecanych dla doradców inwestycyjnych (certyfikowanych przez KNF).</p>
                            <p><strong>Realizacja celów szczegółowych</strong> pozwoli uczestnikom na znaczący wzrost wiedzy i umiejętności w zakresie:
                                <ul>
                                <li>problematyki dotyczącej obrotu gotówkowego i bezgotówkowego oraz bezpieczeństwa dokonywania transakcji w kontekście innowacji technologicznych,</li>
                                <li>podstawowych zasad oszczędzania i inwestowania w gospodarce rynkowej,</li>
                                <li>podstawowych pojęć takich jak kredyt, pożyczka i ubezpieczenia od ryzyka,</li>
                                <li>roli NBP jako instytucji kształtującej stabilność ekonomiczną i finansową Polski.</li>
                            </ul></p>
                        </div>
                    </div>
                </section>
                <section>
                    <img src={pic09} alt="" />
                    <div className="content">
                        <div className="inner">
                            <header className="major2">
                                <h3>Tematy</h3>
                            </header>
                            <p>W ramach projektu będą realizowane cztery główne tematy:</p>
                                <ol>
                                <li>Obrót gotówkowy i bezgotówkowy oraz bezpieczeństwo dokonywania transakcji (zakres tematyczny: historia i funkcje pieniądza, rodzaje pieniądza, innowacje technologiczne w zakresie pieniądza – kryptowaluty, technologia blockchain, zasady bezpieczeństwa podczas dokonywania transakcji bezgotówkowych).</li>
                                <li>Oszczędzanie i inwestowanie (zakres tematyczny: rola oszczędności i inwestycji w gospodarce, istota i rola rynku finansowego w Polsce i na świecie, popularne klasy aktywów inwestycyjnych i potencjalne stopy zwrotu z tych aktywów, zasady bezpiecznego inwestowania).</li>
                                <li>Kredyty, pożyczki, ubezpieczenia (zakres tematyczny: rodzaje kredytów i pożyczek, instytucje kredytowe, instytucje para-bankowe i zagrożenia z nimi związane, kalkulacja kosztów pożyczki lub kredytu, rodzaje ubezpieczeń i system ubezpieczeń w Polsce).</li>
                                <li>Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju (zakres tematyczny: rola najważniejszych instytucji ekonomicznych i finansowych w Polsce, ze szczególnym uwzględnieniem Narodowego Banku Polskiego, Rady Polityki Pieniężnej, Komisji Nadzoru Finansowego, a także Urzędu Ochrony Konkurencji i Konsumentów oraz Giełdy Papierów Wartościowych w Warszawie S.A.).</li>
                            </ol>
                        </div>
                    </div>
                </section>
                
            </section>
            <BackHome />
        </div>

    </Layout>
}

export default Oprojekcie